// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCaregiverAssignedPatients,
  setCaregiverSearchedPatients,
  resetCaregiverAccessRestrictions
} from 'src/store/modules/caregiver/accessRestrictions'

const initialState = {
  assignedPatients: [],
  searchedPatients: []
}

export default handleActions(
  {
    [setCaregiverAssignedPatients](state, { payload: assignedPatients }) {
      return {
        ...state,
        assignedPatients
      }
    },

    [setCaregiverSearchedPatients](state, { payload: searchedPatients }) {
      return {
        ...state,
        searchedPatients
      }
    },

    [resetCaregiverAccessRestrictions]() {
      return initialState
    }
  },
  initialState
)
